namespace GeniuzPOS.ReportMasterData {
    export interface Report_1301Form {
    }

    export class Report_1301Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1301';
    }
}
